import {Component} from '@angular/core';


export class NgbModalBackdrop {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{selector: 'ngb-modal-backdrop', template: '', host: {'class': 'modal-backdrop fade in'}}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
